import { createColumnHelper } from '@tanstack/react-table';

import { ClusterRoleRowData } from '../types';

export const columnHelper = createColumnHelper<ClusterRoleRowData>();
